import { iconSet } from '../app.icons';

const socials = [
  {
    url: 'facebook.com',
    icon: 'facebook',
    title: 'Facebook'
  },
  {
    url: 'instagram.com',
    icon: 'instagram',
    title: 'Instagram'
  }
  ,
  {
    url: 'youtube.com',
    icon: 'youtube',
    title: 'YouTube'
  }
];

export const environment = {
  // base: 'https://macik.local:8443/',
  // base: 'https://',
  // url: 'vint',
  url: 'https://test.vint.cz',
  title: 'Vint',
  slogan: 'Naše společnost Vint interiér s.r.o. se zabývá výrobou atypického mobiliáře a vestavěného nábytku.',
  defaultImage: '/vint/sites/default/files/styles/media_library/public/2024-11/1s9i4717.jpg.webp',
  iconSet,
  socials
};